"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarStyles = void 0;
var avatarStyles = {
  square: {
    borderRadius: 6
  },
  size: {
    tiny: 24,
    small: 32,
    medium: 40,
    large: 64
  }
};
exports.avatarStyles = avatarStyles;